// Returns the core site stats (bookings, doctors, patients) that have a
// real, non-zero value — so templates never show "0+" or fabricated fallbacks.
// fallbackLabels lets each theme keep its own wording when no custom label is set.
export default function visibleStats(config, fallbackLabels = {}) {
  const s = (config && config.stats) || {};
  const L = (config && config.statLabels) || {};
  return [
    ['bookings', L.bookings || fallbackLabels.bookings || 'Appointments'],
    ['doctors', L.doctors || fallbackLabels.doctors || 'Expert Doctors'],
    ['users', L.users || fallbackLabels.users || 'Happy Patients'],
  ]
    .map(([key, label]) => ({ key, label, val: parseInt(s[key], 10) || 0 }))
    .filter((x) => x.val > 0);
}
